import React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from './messages';

import './CardResultDiscipline.scss';

function getWidth(grade, hasSimplificaSpainReports) {
  if (!parseFloat(grade)) return '1px';
  const width = hasSimplificaSpainReports ? parseFloat(grade) * 10 : grade;
  return `${width}%`;
}

const getScoreMessage = hasSimplificaSpainReports =>
  hasSimplificaSpainReports ? messages.averageStudentGrade : messages.score;

function formatGrade(grade, hasSimplificaSpainReports) {
  if (!hasSimplificaSpainReports) return `${grade}%`;
  return `${grade}`.replace('.', ',');
}

const CardResultDiscipline = ({ abbreviation, icon, grade, gradeScaled, hasSimplificaSpainReports }) => (
  <div className="card card-materia">
    <div className="card-body">
      <div className="row align-items-center">
        <div className="col-lg-4">
          <div className="cm-icon">
            <i className={icon} />
          </div>
          <h2 className="cm-title">{abbreviation}</h2>
        </div>
        <div className="col-lg-8">
          <div className="summary flex wrap space-evenly">
            {gradeScaled && (
              <div className="summary-unitary">
                <FormattedMessage {...messages.scaledScore}>
                  {txt => <div>{txt}:</div>}
                </FormattedMessage>
                <div className="percent">{gradeScaled}</div>
              </div>
            )}
            <div className="summary-unitary">
              <FormattedMessage {...getScoreMessage(hasSimplificaSpainReports)}>
                {txt => <div>{hasSimplificaSpainReports ? txt : `${txt}:`}</div>}
              </FormattedMessage>
              <div className="percent">{formatGrade(grade, hasSimplificaSpainReports)}</div>
            </div>
          </div>
          <div className="bar-chart bar-chart-compact horizontal-bars-chart">
            <div className={hasSimplificaSpainReports ? 'bar-chart-wrapper bar-chart-wrapper-bordered' : 'bar-chart-wrapper'}>
              <div className="bc-row">
                <div
                  className="bc-bar bc--yellow"
                  style={{ width: getWidth(grade, hasSimplificaSpainReports) }}
                >
                  <div className="bc-bar-value">{formatGrade(grade, hasSimplificaSpainReports)}</div>
                </div>
              </div>
            </div>
            {hasSimplificaSpainReports ? (
              <div className="bc-numbers">
                <div className="bc-number">0</div>
                <div className="bc-number bc-number-end">10</div>
              </div>
            ) : (
              <div className="bc-number">0</div>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default CardResultDiscipline;
